import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1099547595__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Achtung", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1099547595__cls-1{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M113.03 29.48c-4-6.4-10.88-10.21-18.42-10.21h-.17c-7.61.06-14.5 3.97-18.43 10.48L9.9 139.01c-4.12 6.8-4.24 15-.34 21.93S20.54 172 28.49 172h134.47c8.02 0 15.13-4.19 19.01-11.2 3.89-7.02 3.67-15.26-.59-22.06zM162.97 164H28.49c-5.02 0-9.5-2.61-11.97-6.99s-2.39-9.56.21-13.86L82.85 33.89c2.49-4.11 6.84-6.59 11.65-6.62h.11c4.76 0 9.11 2.41 11.64 6.45l68.36 109.26c2.69 4.3 2.83 9.51.37 13.94s-6.95 7.08-12.02 7.08Z",
      class: "i-1099547595__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M95.73 123.63c-8.82 0-16 7.18-16 16s7.18 16 16 16 16-7.18 16-16-7.18-16-16-16m0 24c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8M95.73 115.63c8.82 0 16-7.18 16-16v-36c0-8.82-7.18-16-16-16-4.27 0-8.29 1.66-11.31 4.69a15.9 15.9 0 0 0-4.69 11.31v36c0 8.82 7.18 16 16 16m-8-52c0-2.14.83-4.15 2.34-5.66a7.95 7.95 0 0 1 5.66-2.34c4.41 0 8 3.59 8 8v36c0 4.41-3.59 8-8 8s-8-3.59-8-8z",
      class: "i-1099547595__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "warning"}) } }